import ParentView from './parent-view.vue'
export default ParentView



// WEBPACK FOOTER //
// ./src/components/parent-view/index.js